import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { EncryptionTab } from './encryption/EncryptionTab';
import ParentDocCard from '../common/ParentDocCard';
import { encryptionText } from '../../common/docs/content';

export class EncryptionSection extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  render() {
    const { appSetting, actions, match } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { projectId, version } = match.params;
    const { environments } = projectDetail;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'encryption'} projectDetail={projectDetail} />
        <EncryptionTab
          projectDetail={projectDetail}
          environments={environments}
          projectId={projectId}
          version={version}
          toggleEncryption={actions.toggleEncryption}
          changeEncryptionType={actions.changeEncryptionType}
          updateEncryptionSetting={actions.updateEncryptionSetting}
          updateEncAwsSetting={actions.updateEncAwsSetting}
          resetEncryptionSetting={actions.resetEncryptionSetting}
          cypherText={actions.cypherText}
        />
        <ParentDocCard>
          <h5>
            <b>About Data Encryption</b>
          </h5>
          <p>{encryptionText}</p>
          <br />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EncryptionSection);
